import React from 'react'

const UserContext2 = React.createContext();
export const UserContextProvider2 = UserContext2.Provider;
export default UserContext2;